export default "/assets/markers/delivered_hover.png"